<script lang="ts">
    import Button from "@smui/button";
    import {createEventDispatcher} from "svelte";
    import {Row} from "svelte-layouts";

    export let svg
    export let text
    export let marginBottom = 0
    export let marginTop = 0

    let disatch = createEventDispatcher()
</script>

<div style="width: 180px; height: 30px; margin-left: auto; margin-right: auto; align-content: start;
 margin-top: {marginTop}px; margin-bottom: {marginBottom}px">
    <Button style="width: 180px; height: 30px; text-transform: none;" on:click={() => {disatch("accountMenuClick")}}>
        <Row style={{width: "100%"}}>
            <img style="width: 24px; height: 24px; text-align: center; margin-right: 15px" src="assets/svg/{svg}.svg" alt={text} />
            <div class="account-menu-text">
                {text}
            </div>
        </Row>
    </Button>
</div>

<style>
    .account-menu-text {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #3A3B45;
    }
</style>